import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { IconNames } from '../../common/constants/icon-names';

export interface InvalidControlGroup {
  index: number;
  fields: string[];
}

@Component({
  selector: 'ui-validation-error-list',
  imports: [TranslateModule, NgForOf, NgIf, SvgIconComponent],
  templateUrl: './validation-error-list.component.html',
  styleUrls: ['./validation-error-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidationErrorListComponent {
  @Input() invalidControls: (string | InvalidControlGroup)[] = [];
  iconNames = IconNames;

  isString(item: string | InvalidControlGroup): boolean {
    return typeof item === 'string';
  }

  isGroup(item: string | InvalidControlGroup): item is InvalidControlGroup {
    return typeof item !== 'string';
  }

  asGroup(item: string | InvalidControlGroup): InvalidControlGroup {
    return item as InvalidControlGroup;
  }
}
